import React, { useEffect } from "react";

import PageLayout from "@acc-monorepo/gatsby-stories-acc/national/layout/PageLayout";
import HeadSeo from "@acc-monorepo/gatsby-stories/seo/HeadSeo";
import {Container, Section} from "@acc-monorepo/gatsby-stories-acc/national/style/national";
import {Button} from "@acc-monorepo/gatsby-stories-acc/buttons/Button";

const FormConfirmationPage = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // prevent double firing on reload/back (keyed by path)
    const key = `conv_fired:${location.pathname}`;
    if (sessionStorage.getItem(key)) return;

    // generate a unique, dedupe-friendly id
    const eventId = 'e' + Date.now().toString(36) + Math.random().toString(36).slice(2);
    sessionStorage.setItem(key, eventId);

    // 1) GTM dataLayer (so your GTM tags can listen if needed)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'DownloadResource',        // <-- change per page (examples below)
      conversion_type: 'DownloadResource',      // <-- optional label you already use
      event_id: eventId
    });

    // 2) Zaraz track (queue-safe if zaraz hasn't loaded yet)
  window.zaraz = window.zaraz || { q: [] };
  window.zaraz.set   = window.zaraz.set   || function(){ this.q.push(arguments); };
  window.zaraz.track = window.zaraz.track || function(){ this.q.push(['track'].concat([].slice.call(arguments))); };    window.zaraz.track('DownloadResource', { // <-- same event name as above
      event_id: eventId,
      conversion_type: 'DownloadResource'
    });
  }, []);

  return (
    <PageLayout>
      <Section>
        <Container>
          <h1>High Five!</h1>
          <p>We have received your form entry, your free copy of the eBook has been sent to your inbox.</p>
          <p>If you're having trouble locating the email please check your spam inbox or contact us.</p>
          <p>Have a great day!</p>

          <Button onClick={() => {window.history.go(-1); return false;}}>CLICK TO GO BACK</Button>
        </Container>
      </Section>
    </PageLayout>
  )
}

export default FormConfirmationPage

export function Head() {
  return (
    <HeadSeo
      title="Thank you, your free copy of the eBook has been sent to your inbox."
      meta={[{name: "robots", content: "noindex, nofollow" }]}
    />
  )
}
